import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-vehicle-form',
    templateUrl: './vehicle-form.component.html',
    styleUrls: ['./vehicle-form.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class VehicleFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
